import type { TranslationTree } from '../../types';

export const home: TranslationTree = {
  home: {
    dashboard: {
      welcome: 'Welcome back',
      description: 'Monitor, analyze, and anticipate tool performance across your active modules.',
      scannerTitle: 'Traceability',
      scannerDescription: 'Scan and track your milling tools',
      analyticsTitle: 'Analytics',
      analyticsDescription: 'Visualize performance and trends',
      mlTitle: 'Machine Learning',
      mlDescription: 'Predict tool wear and remaining life',
      toolViewTitle: 'Tool View',
      toolViewDescription: 'Browse and inspect all registered tools.',
      workshopTitle: 'Workshop',
      workshopDescription: 'Log tool operations and machining sessions.',
      labelizeTitle: 'Labeling',
      labelizeDescription: 'Classify tool-state images to train the predictive-maintenance model.',
      toolRecommenderTitle: 'Tool Eco-Design',
      toolRecommenderDescription:
        'Find optimal cutting tools with AI-powered genetic-algorithm recommendations.',
    },
  },
};
